module.exports = __webpack_public_path__ + "static/media/product-2-full.1f9f7543.jpg";